<template>
	<div ref="SettingDetail" class="dialog-container">
		<div class="dialog scroll" style="transform: translate(0, -300px); max-width: 680px; max-height: 600px;">
			<form @submit.stop="doValidation()">
				<div class="center dialog-flex" style="margin: 0;">
					<div>
						<div class="dialog-tag">
							알림 상세
							<button 
								type="button"
								class="btn-cancel btn-collect"
								:class="isType == true ? 'data-on' : ''"
								style="margin-left: 20px;"
								title="Cancel"
								@click.stop="selectType(true)"
								>
								기본 알림
							</button>
							<button 
								type="button"
								class="btn-cancel btn-collect"
								:class="isType == false ? 'data-on' : ''"
								title="Cancel"
								@click.stop="selectType(false)"
								>
								응급조치 알림
							</button>
						</div>
						<template
							v-for="(alarm, index) in alarmList"
						>
						<table 
								v-if="isType == true"	
								:key="index" class="tb-crud-horizon popup-table" style="margin-top: 30px;"
							>
								<colgroup>
									<col width="140px" />
									<col width="auto" />
									<col width="140px" />
									<col width="auto" />
								</colgroup>
								<tbody>
									<tr style="border-top: 1px solid #191C26">
										<th>참여자 번호</th>
										<td>
											{{ alarm.userId }}
										</td>
									</tr>
									<tr>
										<th>참여자 이름</th>
										<td>
											{{ alarm.name }}
										</td>
									</tr>
									<tr>
										<th>담당자</th>
										<td>
											{{ alarm.userName == '' ? '[시스템 알림]' : alarm.userName}}
										</td>
									</tr>
									<tr>
										<th>데이터 분류</th>
										<td>
											{{ getRecordType(alarm.recordType) }}
										</td>
									</tr>
									<tr>
										<th>상태</th>
										<td class="font-yellow">
											<div class="status" :class="statusColor(alarm.status)">{{getStatusType(alarm.status)}}</div>
										</td>
									</tr>
									<tr>
										<th>반복 횟수</th>
										<td>
											{{ alarm.repeatCnt }}
										</td>
									</tr>
									<tr>
										<th>알림 메시지</th>
										<td>
											{{ alarm.alarmContents }}
										</td>
									</tr>
									<tr>
										<th>수신 날짜</th>
										<td>
											{{ alarm.updateDate.substring(0, 19) }}
										</td>
									</tr>
								</tbody>
							</table>
						</template>
						<template
							v-for="(emergency, index) in emergencyList"
						>
						<table 
								v-if="isType == false"	
								:key="index" class="tb-crud-horizon popup-table" style="margin-top: 30px;"
							>
								<colgroup>
									<col width="140px" />
									<col width="auto" />
									<col width="140px" />
									<col width="auto" />
								</colgroup>
								<tbody>
									<tr style="border-top: 1px solid #191C26">
										<th>참여자 번호</th>
										<td>
											{{ emergency.userId }}
										</td>
									</tr>
									<tr>
										<th>참여자 이름</th>
										<td>
											{{ emergency.name }}
										</td>
									</tr>
									<tr>
										<th>담당자</th>
										<td>
											{{ emergency.userName }}
										</td>
									</tr>
									<tr>
										<th>데이터 분류</th>
										<td>
											{{ getRecordType(emergency.recordType) }}
										</td>
									</tr>
									<tr>
										<th>상태</th>
										<td class="font-yellow">
											<div class="status" :class="statusColor(emergency.status)">{{getStatusType(emergency.status)}}</div>
										</td>
									</tr>
									<tr>
										<th>알림 메시지</th>
										<td>
											{{ emergency.emergencyContents }}
										</td>
									</tr>
									<tr>
										<th>수신 날짜</th>
										<td>
											{{ emergency.updateDate.substring(0, 19) }}
										</td>
									</tr>
								</tbody>
							</table>
						</template>
						<div class="none-list" style="margin-top: 30px;" v-if="alarmList.length == 0 && isType == true"> 
							알림 내역이 없습니다.
						</div>
						<div class="none-list" style="margin-top: 30px;" v-if="emergencyList.length == 0 && isType == false"> 
							알림 내역이 없습니다.
						</div>
					</div>
				</div>
				<div class="bottom" style="display: flex; justify-content: center; column-gap: 10px;">
					<!-- <button type="button" class="btn-cancel" style="margin: 0;" title="Update">
						수정
					</button> -->
					<button type="button" class="btn-cancel" style="margin: 0;" title="Cancel" @click="doCancel()">
						닫기
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
import moment from "moment";

export default {
	name: "SettingDetail",
	created() {
		this.logger.debug(this, "created()");
		this.firstRegistDate = moment().format("YYYY-MM-DD");
		this.firstRegistUserId = this.userInfo.userId;
		this.firstRegistUserName = this.userInfo.userName;
		this.selectUserAlarmList();
	},
	data() {
		return {
			item: {
				id: "",
				name: "",
				userId: sessionStorage.getItem('userId'),
				userName: sessionStorage.getItem('userName'),
				recordType : "",
				status: "",
				alarmContents: "",
				repeatCnt: 0
			},
			isTab: 1,
			alarmList: [],
			emergencyList: [],
			isType: true,
		};
	},
	components:{
	},
	props: {
		selectData: {
			type: Object,
			required: true
		},
	},
	methods: {
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					if (result)
					{
						this.$confirm("Do you want to register the current Question Group?", "Question", "question").then(() => {
							EventBus.$emit("field-loading", true);
							this.doInsert();
						});
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		selectType(bool){
			this.isType = bool;
		},
		selectUserAlarmList(){
			this.logger.debug(this, "selectAlarmList()");
			this.openProjectIndex = -1;
			axios
				.post(this.config.contextRoot + "/alarm/selectUserAlarmList.do", this.selectData)
				.then((response) => {
					console.log(response);
					this.alarmList = response.data.alarmList;
					this.emergencyList = response.data.emergencyList;
					// this.pagination = response.data.pagination;

					EventBus.$emit("project-loading", false);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");
			axios
				.post(this.config.contextRoot + "/field/insertGroup.do", this.item)
				.then((response) => {
					if (response.status == 200)
					{
						console.log(response);
						// location.reload();
						this.$alert("Complete", "Success", "success").then(() => {
							// location.reload();
							this.$parent.selectProjectList();
							this.$parent.selectQuestionGroupList();
							this.doClose();
						});
					}
					else
					{
						alert(response);
						console.log(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("취소하시겠습니까?", "Question", "question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.SettingDetail.style.animation = "fadeOut 0.4s ease-in-out both";
			this.$refs.SettingDetail.children[0].style.animation = "fadeOutDrop 0.4s ease-in-out both";
			setTimeout(function() {
				EventBus.$emit("project-cancel", "isDataPopup");
			}.bind(this), 410);
		},
		changeTap(type){
			this.isTab = type;
		},
		statusColor(status){
			var result = "green";
			if(status == 'EMERGENCY'){
				result = 'red'
			}
			if(status == 'CAUTION'){
				result = 'yellow'
			}
			return result;
		},
		getRecordType(recordType){
			var result = "";

			if(recordType == 'WEIGHT'){
				result = '체중'
			}
			if(recordType == 'BLOOD_PRESSURE'){
				result = '혈압'
			}
			if(recordType == 'BLOOD_GLUCOSE'){
				result = '혈당'
			}
			if(recordType == 'HEART_RATE'){
				result = '심박수'
			}
			if(recordType == 'STEP_COUNT'){
				result = '걸음수'
			}
			if(recordType == 'CALORIE'){
				result = '칼로리'
			}
			if(recordType == 'PROTEINURIA'){
				result = '단백뇨'
			}
			if(recordType == 'OXYGEN_SATURATION'){
				result = '산소포화도'
			}
			if(recordType == 'STRESS'){
				result = '스트레스'
			}
			if(recordType == 'SLEEP_TIME'){
				result = '수면시간'
			}

			return result;
		},
		getStatusType(status){
			var result = "정상";
			if(status == 'EMERGENCY'){
				result = '경고'
			}
			if(status == 'CAUTION'){
				result = '주의'
			}
			return result;
		},
	}
};
</script>

<style scoped>
.btn-cancel {
	margin-right: 10px;
}
.popup-table th{
	background-color: #F8F9FB;
}
.popup-table tr:first-child > th{
	border-top: 1px solid #191C26
}
.popup-table tr:first-child > td{
	border-top: 1px solid #191C26
}
.dialog-tag{
	font-size: 18px;
	font-weight: bold;
}
.dialog-flex{
	display: flex;
    column-gap: 40px;
    justify-content: space-between;
	margin: 
}
.dialog-flex > div{
	width: 100%;
}
.popup-table td{
	border-left: 1px solid #ddd;
	border-right: 1px solid #ddd;
}
.popup-table td:last-child{
	border-right: none;
}
.participant-tab-zone{
	width: 100%;
	height: 48px;
	margin-top: 20px;
	background-color: #EBF4FF;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 0 5px;
	column-gap: 5px;
}
.participant-btn{
	height: 40px;
	border-radius: 6px;
	display: flex;
    justify-content: center;
    align-items: center;
	flex: 1;
	color: #090909;
	font-size: 18px;
	cursor: pointer;
}
.participant-btn:hover{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.participant-on{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.font-red{
	color: #F94848;
}
.font-yellow{
	color: #FFAD09;
}
.data-on{
	color: #fff;
	background-color: #0176F9;
}
</style>